import { Fragment } from 'react';
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { IBannerItem } from '@type/index';

const BannerItem = ({ data }: {data: IBannerItem}) => {
    const { image, label, title, link } = data || {};
    return <div className="banner-item" {...(image ? {style: {backgroundImage: `url(${image})`}} : {})}>
        <span className="banner-label">{label}</span>
        <p className="banner-title" dangerouslySetInnerHTML={{__html: title}}></p>
    </div>;
};

export const Banner = ({ data }: {data: IBannerItem[]}) => {
    return Array.isArray(data) && data?.length > 0 ?
    <section className="banner-wrap">
        <Swiper
            modules={[Autoplay, Pagination]}
            slidesPerView={1}
            navigation={false}
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000 }}
            speed={800}
            loop={true}>
            {
                data?.map((item, i) => <SwiperSlide key={`banner-${i}`} className="banner-item-wrap">
                    { item?.link ? <a href={item.link} data-contents="배너_배너_클릭"><BannerItem data={item}/></a> : <BannerItem data={item} /> }
                </SwiperSlide>)
            }
        </Swiper>
    </section>
    : <Fragment />;
};